import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TabComponent } from '../tab-component';
import { ProfileService } from 'app/profile/services/profile.service';
import { SearchResult, Asset, Tool, ToolFilter, ToolCategory, ToolSubcategory, ToolDeliverable, ToolAsset, GeneralSettings, ToolProcessFlow, DataThatIsBeingExported, Part, PartSupplierDetails } from 'app/profile/models/generic.model';
import { PageEvent, TslOption, TslSelectChange, TslDialog } from '@tesla/ng-tds';
import { Observable, combineLatest } from 'rxjs';
import { FormControl } from '@angular/forms';
import { debounceTime, startWith, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from 'app/profile/services/state.service';
import { I18nService } from 'app/shared/services/i18n.service';
import { Store, select } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { GetSupplierProfileCurrentUser, GetToolCategories, GetToolSubCategories, GetSupplierLocationsByCode,GetPreventativeInProgress } from 'app/profile/store/app.actions';
import { SelectCurrentUser, SelectToolCategories, SelectToolSubCategories, getGeneralSettings, SelectSupplierLocations,SelectPreventativeInProgress } from 'app/profile/store/app.selector';
import { UserDetails } from 'app/profile/models/user.model';
import { MatDialog } from '@angular/material/dialog';
import { ManageDefaultsComponent } from './manage-defaults/manage-defaults.component';
import { ToolEquipmentFormComponent } from './tool-equipment-form/tool-equipment-form.component';
import { any } from 'underscore';
import * as XLSX from "xlsx";
import { StatusEnum } from 'app/profile/models/state.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'tool-equipment',
  templateUrl: './tool-equipment.component.html',
  styleUrls: ['./tool-equipment.component.scss']
})
export class ToolEquipmentComponent implements OnInit, TabComponent {
  @Input() data: any;
  supplierCode: string;
  assets: Asset[];
  availableAssets: Asset[];
  editMode = false;
  selectedTool: Tool;
  deleteTitle: string;
  deleteConfirmation: string;

  preventativeHold: boolean =false;
  errorTitle: string;
  errorMessage1: string;
  errorMessage2: string;
  errorMessage3: string;

  // table certifications
  pageIndex = 0;
  pageSize = 50;
  pageSizeOptions = [10, 25, 50, 100, 250];
  toolResult = new SearchResult<Tool>();
  displayedColumns: Array<string> = ['name', 'category', 'subCategory', 'isAsset', 'assetNumber', 'status', 'action'];

  // filter
  filter: ToolFilter = new ToolFilter();
  filterAssetNumber = new FormControl();
  filterAssetsFiltered$: Observable<any>;
  filterCategories: ToolCategory[];
  filterSubcategories: ToolSubcategory[];
  allSubcategories: ToolSubcategory[];
  userDetails: UserDetails;
  helpUrl: string;
  settings: GeneralSettings;
  @ViewChild('toolEquipmentForm') toolEquipmentForm: ToolEquipmentFormComponent;
  isEquipment: boolean = true;

  //Tool's associated process flow information
  processFlows: ToolProcessFlow[] = [];
  partNumbers: string[];
  processStepNames: string[];
  tabType: string;




  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public translate: I18nService,
    private dialog: TslDialog,
    private stateService: StateService,
    private service: ProfileService,
    private store: Store<SupplierState>,
    private datepipe: DatePipe,
    private matDialog: MatDialog) {
  }

  ngOnInit() {
    this.service
    this.route.url.subscribe(x => {
      this.tabType = x[x.length - 1].toString();
      this.isEquipment = this.tabType.toLowerCase() != 'tool';
    });
    this.store.select(getGeneralSettings).subscribe(res => {
      this.settings = res;
      if (res) {
        this.helpUrl = this.settings.settings.toolHelpUrl;
      }
    });
    this.route.parent.params.subscribe(params => {
      if (!params["code"]) {
        return;
      }

      this.supplierCode = params["code"];
      this.filter.isEquipment = this.isEquipment;
      this.store.dispatch(new GetSupplierProfileCurrentUser());

      this.store.pipe(select(SelectCurrentUser)).subscribe(result => {
        if (result) {
          this.userDetails = result;
          this.loadResources();
        }
      });

    });
    
    if (this.supplierCode) { 
      this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });
    }
  }

  public isDirty() {
    return this.toolEquipmentForm ? !this.toolEquipmentForm.canDeactivate() : false;
  }

  onSaveTab(tab: string): void {
    if ((tab === "Tool" || tab === "Equipment") && this.editMode) {
      // save event trigger from header
    }
  }

  onPageChange(pageChange: PageEvent) {
    const { pageIndex, pageSize } = pageChange;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    this.loadTable();
  }

  createTool(): void {
    this.selectedTool = new Tool();
    this.selectedTool.isEquipment = this.isEquipment;
    this.selectedTool.supplierCode = this.supplierCode;
    this.toggleForm();
  }

  exportToExcel(): void {
    let exportFilter: ToolFilter = new ToolFilter();
    exportFilter.skip = 0;
    exportFilter.take = 10000;
    exportFilter.isEquipment = this.isEquipment;
    let partsArray: any = {};


    this.service.searchTools(this.supplierCode, exportFilter).subscribe((res) => {
      if (res && res.items && res.items.length > 0) {
        let associatedPartsStr = res.items.map(x => x.data && x.data.associatedParts ? x.data.associatedParts.map(y => y.partNumber).join(',') : "").join(',');
        let associatedPartsArr = associatedPartsStr.split(',');
        let associatedParts = Array.from(new Set(associatedPartsArr));
        if (associatedParts && associatedParts.length > 0) {
          this.service.getPartSupplierDetails(this.supplierCode, associatedParts).subscribe((partsuppliers: PartSupplierDetails[]) => {
            if (partsuppliers) {
              partsuppliers.forEach(x => {
                partsArray[x.partNumber] = x.demandType;
              });
            }
            this.downloadExportData(res, partsArray);
          });
        } else {
          this.downloadExportData(res, partsArray);
        }
      } else {
        this.stateService.currentStatus.next({ type: StatusEnum.Warning, message: 'There are no tools found' });
      }
    });
  }

  downloadExportData(res: any, partsArray: any) {
    let excelToolDataList: DataThatIsBeingExported[] = [];
    let srNumber = 0;
    for (let i = 0; i < res.items.length; i++) {
      let toolRow = new DataThatIsBeingExported();
      toolRow.srNumber = ++srNumber;
      toolRow.toolType = this.isEquipment ? "Equpiment" : "Tool";
      let toolData = res.items[i];
      toolRow.toolName = toolData.data.name;
      toolRow.toolCategory = toolData.toolCategory;
      toolRow.toolSubcategory = toolData.toolSubcategory;
      if (toolData.data.assets) {
        var assetCodesOfCurrentTool = toolData.data.assets.map(function (asset) {
          return asset['assetCode'];
        });
        var assetDescriptionOfCurrentTool = toolData.data.assets.map(function (asset) {
          return asset['assetDescription'];
        });
        var assetStatusOfCurrentTool = toolData.data.assets.map(function (asset) {
          return asset['assetStatus'];
        });
        toolRow.assetCode = assetCodesOfCurrentTool.toString();
        toolRow.assetDescription = assetDescriptionOfCurrentTool.toString();
        toolRow.assetStatus = assetStatusOfCurrentTool.toString();
      } else {
        toolRow.assetCode = "NA";
        toolRow.assetDescription = "NA";
        toolRow.assetStatus = "NA";
      }
      toolRow.toolStatus = toolData.data.status;
      toolRow.expendable = toolData.data.isExpendable ? "Yes" : "No";
      toolRow.expirationDate = toolData.data.expirationDate ? this.datepipe.transform(toolData.data.expirationDate) : "NA";
      toolRow.partsUntilExpirations = toolData.data.numberOfParts ? toolData.data.numberOfParts : "NA";
      if (toolData.data.associatedParts && toolData.data.associatedParts.length > 0) {
        var associatedPartsNumberOfCurrentTool = toolData.data.associatedParts.map(function (associatedPart) {
          return associatedPart['partNumber'];
        });
        toolRow.associatedParts = associatedPartsNumberOfCurrentTool.toString();
        var demandStatuses = toolData.data.associatedParts.map(function (associatedPart) {
          return partsArray[associatedPart['partNumber']];

        });
        toolRow.demandStatus = demandStatuses.join(',');
      } else {
        toolRow.associatedParts = "NA";
        toolRow.demandStatus = "NA";
      }
      if (!toolData.data.deliverable || toolData.data.deliverable.length == 0) {
        excelToolDataList.push(toolRow);
      } else {
        for (let j = 0; j < toolData.data.deliverable.length; j++) {
          let toolRowDeliverable: DataThatIsBeingExported = JSON.parse(JSON.stringify(toolRow));
          if (j > 0) {
            toolRowDeliverable.srNumber = ++srNumber;
          }
          let toolDeliverable:ToolDeliverable = toolData.data.deliverable[j];
          if (toolDeliverable.eventType == 0) {
            toolRowDeliverable.event = "Design";
          } else if (toolDeliverable.eventType == 1) {
            toolRowDeliverable.event = "Build";
          } else if (toolDeliverable.eventType == 2) {
            toolRowDeliverable.event = "Commission";
          } else if (toolDeliverable.eventType == 3) {
            toolRowDeliverable.event = "Maintenance";
          }
          toolRowDeliverable.deliverable = toolDeliverable.deliverable;
          toolRowDeliverable.deliverableType = toolDeliverable.isDefault ? "Global": "Other";
          toolRowDeliverable.startDate = toolDeliverable.startDate ? this.datepipe.transform(toolDeliverable.startDate) : "NA";
          toolRowDeliverable.plannedDate = toolDeliverable.plannedDate ? this.datepipe.transform(toolDeliverable.plannedDate) : "NA";
          toolRowDeliverable.actualDate = toolDeliverable.actualDate ? this.datepipe.transform(toolDeliverable.actualDate) : "NA";
          if (toolDeliverable.status == 1) {
            toolRowDeliverable.deliverableStatus = "Submitted";
          } else if (toolDeliverable.status == 2) {
            toolRowDeliverable.deliverableStatus = "Rejected";
          } else if (toolDeliverable.status == 3) {
            toolRowDeliverable.deliverableStatus = "Approved";
          } else if (toolDeliverable.status == 4) {
            toolRowDeliverable.deliverableStatus = "NotSubmitted";
          }

          excelToolDataList.push(toolRowDeliverable);
        }
      }
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const toolList = JSON.parse(JSON.stringify(excelToolDataList));
    let heading = [["Sr. No",
      "Tool/Equipment",
      "Tool Name",
      "Tool Category",
      "Tool sub-Category",
      "Asset Tag Number",
      "Asset Description",
      "Asset Status",
      "Tool Status",
      "Expendable",
      "Expiration date",
      "No of parts until Expiration",
      "Associated Parts",
      "Demand status",
      "Event",
      "Deliverable",
      "Deliverable Type",
      "Start date",
      "Planned date",
      "Actual date ",
      "Status"]];
    let objectMaxLength = [];
    for (let i = 0; i < heading.length; i++) {
      let value = heading[i];
      for (let j = 0; j < value.length; j++) {
        if (typeof value[j] == "number") {
          objectMaxLength[j] = 10;
        } else {
          let valueLength = (value[j] ? value[j].length : 0);
          objectMaxLength[j] =
            objectMaxLength[j] >= valueLength
              ? objectMaxLength[j]
              : valueLength;
        }
      }
    }
    for (let i = 0; i < toolList.length; i++) {
      let value = <any>Object.values(toolList[i]);
      for (let j = 0; j < value.length; j++) {
        if (typeof value[j] == "number") {
          objectMaxLength[j] = 10;
        } else {
          let valueLength = (value[j] ? value[j].length : 0);
          objectMaxLength[j] =
            objectMaxLength[j] >= valueLength
              ? objectMaxLength[j]
              : valueLength;
        }
      }
    }

    var wscols = [
      { width: objectMaxLength[0] },  // first column
      { width: objectMaxLength[1] }, // second column
      { width: objectMaxLength[2] }, //...
      { width: objectMaxLength[3] },
      { width: objectMaxLength[4] },
      { width: objectMaxLength[5] },
      { width: objectMaxLength[6] },
      { width: objectMaxLength[7] },
      { width: objectMaxLength[8] },
      { width: objectMaxLength[9] },
      { width: objectMaxLength[10] },
      { width: objectMaxLength[11] },
      { width: objectMaxLength[12] },
      { width: objectMaxLength[13] },
      { width: objectMaxLength[14] },
      { width: objectMaxLength[15] },
      { width: objectMaxLength[16] },
      { width: objectMaxLength[17] },
      { width: objectMaxLength[18] },
      { width: objectMaxLength[19] },
      { width: objectMaxLength[20] },
    ];

    var worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, heading);

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(worksheet, toolList, { origin: 'A2', skipHeader: true });
    worksheet["!cols"] = wscols;
    XLSX.utils.book_append_sheet(wb, worksheet, "Sheet1");
    /* save to file MMDDYYYYHHMMSS*/
    let currentDateTimeStamp = this.datepipe.transform(new Date(), "MMddyyyyhhmmss");
    let fileName: string = "SupplierProfile_Tool&EquipmentDetails_" + currentDateTimeStamp + ".xlsx";
    XLSX.writeFile(wb, fileName);
  }

  onEditTool(tool: Tool): void {
    if(tool.id){
    const filter = new ToolFilter();
    filter.skip = 0;
    filter.take = 1;
    filter.toolId = tool.id;
      this.service.searchTools(this.supplierCode, filter).subscribe( res => {
        if(res){
          this.selectedTool = res.items[0];
          this.toggleForm();
        }
      });
    } else {
      this.selectedTool = tool;
      this.toggleForm();
    }
  }

  closeForm(isReload): void {
    this.toggleForm();
    if (isReload) {
      this.onFilter();
    }
  }

  onFilter(): void {
    this.loadTable();
  }

  onClearFilter(): void {
    this.filter = new ToolFilter();
    this.filter.isEquipment = this.isEquipment;
    this.filterAssetNumber.setValue('');
    this.pageIndex = 0;
    this.pageSize = this.pageSizeOptions[0];
    this.loadTable();
  }

  onSelectFilterAsset(option: TslOption): void {
    this.filter.assetId = option.value.assetId;
  }

  onChangeCategory(event: TslSelectChange): void {
    this.filter.categoryId = event.value;

    const categoryId = parseInt(event.value || 0, 0);
    this.filterSubcategories = JSON.parse(JSON.stringify(this.allSubcategories.filter(x => x.toolCategoryId === categoryId || categoryId === 0)));
  }

  onChangeSubcategory(event: TslSelectChange): void {
    this.filter.subcategoryId = event.value;
  }

  assetAutoDisplay(asset: ToolAsset): string {
    return asset !== undefined ? `${asset.assetCode} - ${asset.assetDescription} ${asset.assetStatus ? ' - (' + this.convertToTitleCase(asset.assetStatus) + ')' : ''}` : '';
  }

  tooolAssetAutoDisplay(toolStatus: string): string {
    return toolStatus !== undefined && toolStatus != null ? this.convertToTitleCase(toolStatus) : '';
  }

  onCopyTool(sourceTool: Tool): void {
    const sourceToolStr = JSON.stringify(sourceTool);
    const newTool: Tool = JSON.parse(sourceToolStr);

    // set default values
    newTool.id = 0;
    newTool.data.name += "-copy";
    newTool.data.deliverable = [];
    newTool.data.assets = [];

    this.selectedTool = newTool;
    this.toggleForm();
  }

  onMoveTool(tool: Tool): void {
    tool.isEquipment = !tool.isEquipment;

    this.service.putTool(this.supplierCode, tool)
      .subscribe(_ => {
        this.onFilter();
      });
  }

  onDeleteTool(tool: Tool): void {
    this.dialog.confirm(this.translate.get(this.deleteTitle), this.translate.get(this.deleteConfirmation))
      .afterClosed()
      .subscribe(confirmed => {
        if (confirmed) {
          this.service.getProcessFlowByToolId(tool.supplierCode, tool.id).subscribe((res: ToolProcessFlow[]) => {
            if (res.length == 0) {
              this.service.deleteTool(this.supplierCode, tool.id)
                .subscribe(_ => {
                  this.onFilter();
                });
            }
            else {
              this.processFlows = res;
              this.partNumbers = this.processFlows.map(processFlow => processFlow.partNumber);
              this.processStepNames = [].concat.apply([], this.processFlows.map(processFlow => processFlow.processSteps.map(processStep => processStep.processStepName)));

              this.dialog.alert(this.errorTitle, this.errorMessage1 + this.processStepNames.join(', ') + this.errorMessage2 + this.partNumbers.join(', ') + this.errorMessage3);
            }
          });
        }
      });
  }

  manageDefaults(): void {
    const dialogRef = this.matDialog.open(ManageDefaultsComponent, {
      width: '68%',
      minWidth: '730px',
      // height: '60%',
      // minHeight: '650px', //sreechanges
      data: { supplierCode: this.supplierCode }
    });

    dialogRef.afterClosed().subscribe(x => {
      // TODO
    });
  }

  private toggleForm(): void {
    this.editMode = !this.editMode;
  }

  private loadResources(): void {
    this.store.dispatch(new GetToolCategories());
    this.store.dispatch(new GetToolSubCategories(this.supplierCode, true));
    this.store.dispatch(new GetSupplierLocationsByCode(this.supplierCode, true));
    combineLatest(
      [this.store.select(SelectToolCategories),
      this.store.select(SelectToolSubCategories),
      this.store.select(SelectSupplierLocations)])
      .subscribe(([categories, subCategories, locations]) => {
        if (categories && subCategories) {
          this.filterCategories = categories.sort((a, b) => a.category.trim().toLowerCase().localeCompare(b.category.trim().toLowerCase(), undefined, { sensitivity: 'base' }));
          this.allSubcategories = subCategories[this.supplierCode].sort((a, b) => a.subcategory.trim().toLowerCase().localeCompare(b.subcategory.trim().toLowerCase(), undefined, { sensitivity: 'base' }));
          this.filterSubcategories = this.allSubcategories;
        }
      });

    this.loadTable();


    this.filterAssetsFiltered$ = this.filterAssetNumber.valueChanges
      .pipe(
        debounceTime(300),
        startWith(' '),
        map(value => this.filterAsset(value))
      );

    this.stateService.savedState
      .subscribe(s => this.onSaveTab(s));

    this.translate.getAsync('Delete Item')
      .subscribe(t => this.deleteTitle = t);

    this.translate.getAsync('Are you sure you want to delete this item?')
      .subscribe(t => this.deleteConfirmation = t);

    this.translate.getAsync('Deletion Error')
      .subscribe(t => this.errorTitle = t);

    this.translate.getAsync('Deletion Error Message1')
      .subscribe(t => this.errorMessage1 = t);

    this.translate.getAsync('Deletion Error Message2')
      .subscribe(t => this.errorMessage2 = t);

    this.translate.getAsync('Deletion Error Message3')
      .subscribe(t => this.errorMessage3 = t);

  }

  //this needs to be changed to loadToolTable
  private loadTable(): void {
    if (this.isEquipment) {
      this.filter.skip = this.pageIndex * this.pageSize;
      this.filter.take = this.pageSize;

      combineLatest(
        [this.service.searchTools(this.supplierCode, this.filter)])
        .subscribe(([res]) => {
          if (res) {

            // Add all the available assets as fake tool item in tool grid
            // if (res && res.items) {
            //     res.items.push(...fakeAssetTools);
            // }
            if (res && res.items) {
              const totalSkip = this.filter.skip - res.items.length;
              const totalItems = totalSkip - res.totalRecords;

              res.items.forEach(x => {
                if (x.data) {
                  x.data.status = x.data.status;
                }
              })
            }
            res.totalRecords = res.totalRecords;
            this.toolResult = res;
          }
        });
    } else {

      this.filter.skip = this.pageIndex * this.pageSize;
      this.filter.take = this.pageSize;

      combineLatest(
        [this.service.searchTools(this.supplierCode, this.filter),
        this.service.getAssets(this.supplierCode, false)])
        .subscribe(([res, allAssetData]) => {
          if (res && allAssetData) {
            this.assets = allAssetData;
            this.availableAssets = this.assets.filter(x => x.isAvailable === true);
            let fakeAssetTools = this.availableAssets.map(x => {
              let tool = new Tool();
              tool.assetId = x.assetId;
              tool.data.assets = [];
              let toolAsset = new ToolAsset();
              toolAsset.assetId = x.assetId;
              toolAsset.assetCode = x.assetCode;
              toolAsset.assetDescription = x.assetDescription;
              toolAsset.assetStatus = x.assetStatus;
              toolAsset.cmtNumber = x.cmtNumber;
              toolAsset.cmtStatus = x.cmtStatus;
              tool.data.assets.push(toolAsset);
              tool.supplierCode = this.supplierCode;
              tool.isEquipment = this.isEquipment;
              tool.data.isTeslaAsset = true;
              return tool;
            })

            // Add all the available assets as fake tool item in tool grid
            // if (res && res.items) {
            //     res.items.push(...fakeAssetTools);
            // }
            if (res && res.items) {
              const fakeAssetLength = fakeAssetTools.length;
              const totalSkip = this.filter.skip - res.items.length;
              const totalItems = totalSkip - res.totalRecords;
              if (res.items.length < this.pageSize) {
                if (totalItems <= 0) {
                  if (fakeAssetLength >= totalSkip) {
                    if (totalSkip == 0) {
                      res.items.push(...fakeAssetTools.slice(0, fakeAssetLength >= this.pageSize ? this.pageSize : fakeAssetLength));
                    }
                    else {
                      res.items.push(...fakeAssetTools.slice(0, fakeAssetLength - (this.pageSize - res.items.length) > 0 ? this.pageSize - res.items.length : fakeAssetLength));
                    }
                  } else if (fakeAssetTools.length > 0) {
                    res.items.push(...fakeAssetTools.slice(0, fakeAssetTools.length));
                  }
                } else {
                  if (fakeAssetLength >= (totalItems + this.pageSize)) {
                    res.items.push(...fakeAssetTools.slice(totalItems, this.pageSize + totalItems));
                  } else if (fakeAssetTools.length > totalItems) {
                    res.items.push(...fakeAssetTools.slice(totalItems, fakeAssetTools.length + totalItems));
                  }
                }
              }

              res.items.forEach(x => {
                if (x.data) {
                  x.data.status = x.data.status;
                }
              })
            }
            res.totalRecords = res.totalRecords + fakeAssetTools.length;
            this.toolResult = res;
          }
        });
    }
  }

  private convertToTitleCase(status: string): string {
    if (status == "active") {
      return "Active"
    }
    else if (status == "future") {
      return "Future"
    }
    else if (status == "service") {
      return "Service"
    }
    else if (status == "notactive") {
      return "NotActive"
    }
    return "";

  }

  private getToolStatus(assetData: Asset[]) {
    // Active: if any of the assets is active, then the tool status will be active
    //Future: if there are no active assets but there are any assets in future, then the tool status will be future
    //Service:  if there are no active and no future, but there are any assets in service, then the tool status will be service
    //Not active
    // TODO based on Asset Status:  NULL, Closed, Open, Scrapped, Not yet acquired
    //assetData.some(x=>x.status && x.status.toLocaleLowerCase() == "")
  }

  private filterAsset(value: string): Asset[] {
    const filterValue = value.toLowerCase();
    if (this.assets) {
      return this.assets.filter(
        option => option.assetCode
          .toLowerCase()
          .includes(filterValue));
    }
  }

  openAddress() {
    this.router.navigateByUrl(`${this.supplierCode}`);
  }
}
